import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Building2 } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import { getAdminOrganizations, type AdminOrganization } from '../lib/api'
import RowActions from '../components/RowActions'

export default function TenantsPage() {
  const { token } = useAuth()
  const navigate = useNavigate()
  const [orgs, setOrgs] = useState<AdminOrganization[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!token) return
    getAdminOrganizations(token)
      .then(setOrgs)
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [token])

  return (
    <div className="p-8 space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-white">Tenants</h1>
        <button
          onClick={() => navigate('/sales/tenants/create')}
          className="rounded bg-yellow-500 px-4 py-2 text-xs font-bold text-black hover:bg-yellow-400 transition-colors"
        >
          + NEW TENANT
        </button>
      </div>

      {loading ? (
        <p className="text-zinc-400 text-sm">Loading…</p>
      ) : orgs.length === 0 ? (
        <div className="rounded-xl border border-zinc-800 bg-zinc-900 p-12 text-center">
          <Building2 size={32} className="text-zinc-700 mx-auto mb-3" />
          <p className="text-zinc-400 text-sm">Belum ada tenant.</p>
          <p className="text-zinc-600 text-xs mt-1">Buat tenant pertama untuk mulai onboarding organizer.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-zinc-800 bg-zinc-900 overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-zinc-800">
                <th className="text-left px-5 py-3 text-[11px] font-semibold text-zinc-500 uppercase tracking-wider">Nama</th>
                <th className="text-left px-5 py-3 text-[11px] font-semibold text-zinc-500 uppercase tracking-wider">Slug</th>
                <th className="text-left px-5 py-3 text-[11px] font-semibold text-zinc-500 uppercase tracking-wider">Dibuat</th>
                <th className="px-5 py-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800">
              {orgs.map(org => (
                <tr key={org.id} className="hover:bg-zinc-800/50 transition-colors">
                  <td className="px-5 py-4">
                    <button
                      className="text-white font-medium hover:text-yellow-400 transition-colors text-left"
                      onClick={() => navigate(`/sales/tenants/${org.id}/overview`)}
                    >
                      {org.name}
                    </button>
                  </td>
                  <td className="px-5 py-4 text-zinc-400 font-mono text-xs">{org.slug}</td>
                  <td className="px-5 py-4 text-zinc-500 text-xs">
                    {new Date(org.created_at).toLocaleDateString('id-ID', {
                      day: 'numeric', month: 'short', year: 'numeric',
                    })}
                  </td>
                  <td className="px-5 py-4 text-right">
                    <RowActions
                      actions={[
                        { label: 'Detail', onClick: () => navigate(`/sales/tenants/${org.id}/overview`) },
                        { label: 'Edit', onClick: () => navigate(`/sales/tenants/${org.id}/edit`) },
                      ]}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
